import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Subscription from './Subscription';
import styles from './styles';

function mapStateToProps(state) {
  const { isLoading, data } = state.dev;
  return {
    isLoading,
    data,
  };
}

const Styled = withStyles(styles)(Subscription);

export default connect(
  mapStateToProps,
)(Styled);
